import React, {Fragment, Suspense} from 'react';
import cx from "classnames";
import { Col, ModalFooter, Row } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { duration_option_list, workflow_action_list } from '../Search/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalBody } from "reactstrap";
import TaskAction from './Actions/TaskAction';
import SendAction from './Actions/SendAction';
import { confirmBoxWithImage, decodeString, getSystemActionContent, getWAComponents, getWATemplateDetails, isAddonModuleEnabled, parseExtraRecipients, parseJSON, parseSendActionExpression, populateRecipientOptionList, randstr, showToast } from '../../Common/Appcommon';
import UpdateAction from './Actions/UpdateAction';
import QuickReplyOperations from '../QuickReply/QuickReplyOperations';
import SendWebhookAction from './Actions/SendWebhookAction';

class ActionList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            actionList : [],
            isShowEditorModal : false,
            currentEditor : "",
            actionBtnTxt : "",
            defaultDuration : duration_option_list[0],
            conditionData: [],
            showActionDelay : false,
            disableChangeAction : false,
            currentActionName : "",
            actions : props.actions,
            index : props.index,
            selectedUserAction : {},
        }
    }

    componentDidMount = async () => {
        let {index, selectedActions, actions, selectedUserAction} = this.props;
        let action = actions[index];
        if(action !== undefined){
            let delayType = action['delayType'];
            let delayValue = action['delayValue'];
            let conditionData = {};
            conditionData['delay_value'] = delayValue;
            let currentDuration = [];
            for(let di = 0; di < duration_option_list.length; di++){
                if(duration_option_list[di].value === delayType){
                    currentDuration = duration_option_list[di];
                    break;
                }
            }
            this.setState({
                selectedUserAction : selectedUserAction,
                actionList : selectedActions,
                showActionDelay : actions[index] !== undefined,
                disableChangeAction : actions[index] !== undefined,
                conditionData, defaultDuration : currentDuration
            });
        }
        this.getActionButtonText(actions, index);
        
    }

    componentWillReceiveProps = async (nextProps) => {
        let {actions, index, selectedActions} = nextProps;
        let action = actions[index];
        if(action !== undefined){
            let delayType = action['delayType'];
            let delayValue = action['delayValue'];
            let conditionData = {};
            conditionData['delay_value'] = delayValue;
            let currentDuration = [];
            for(let di = 0; di < duration_option_list.length; di++){
                if(duration_option_list[di].value === delayType){
                    currentDuration = duration_option_list[di];
                    break;
                }
            }
            this.setState({
                actionList : selectedActions,
                showActionDelay : actions[index] !== undefined,
                disableChangeAction : actions[index] !== undefined,
                conditionData, defaultDuration : currentDuration,
                index : index,
                actions : actions
            });
        
        }
        this.getActionButtonText(actions, index);
    }

    onActionChange = async (action, name) => {
        let {actionList, index, actions} = this.state;
        actionList[name] = action;
        this.getActionButtonText(actions, index);
        this.setState({
            actionList
        })
    }

    enableActionDelay = () => {
        let {defaultDuration} = this.state;
        let {onActionExecutionChange, index} = this.props;
        this.setState({
            showActionDelay: true
        });
        onActionExecutionChange("delayType",index, defaultDuration.value);
    }

    getActionButtonText =  (actions, index) =>{
        //let {actions, index} = this.state;

        //let {index, actions} = this.props;
        let btnTxt = "Configure";
        if(actions[index] !== undefined){
            let action = actions[index];
            if(action['action_name'] !== undefined){
                btnTxt = action['action_name'];
            }
           // btnTxt = actions[index] !== undefined ? "Update Configuration" : "Configure";
            //alert("btnTxt: "+btnTxt);
            /*if(action.value === "create_task"){
                btnTxt = actions[actionIndex] !== undefined ? "Update Configuration" : "Configure";
            } else if(action.value === "send_email"){
                btnTxt = "Send Email";
            } else if(action.value === "send_whatsapp"){
                btnTxt = "Send Whatsapp";
            } else if(action.value === "send_sms"){
                btnTxt = "Send SMS";
            } else if(action.value === "update_field"){
                btnTxt = "Configure Fields";
            } else if(action.value === "webhook"){
                btnTxt = "Create Webhook";
            }*/
        }
        this.setState({
            actionBtnTxt : btnTxt
        })
    }

    configureActionContent = async(e, actionName) => {
        let editor = "";
        let {actions, index} = this.state;
        let {control, errors, onSelectChange, screenDetail, systemActionSubmit} = this.props;
        if(actionName === "send_whatsapp" && !isAddonModuleEnabled("whatsapp")){
            await confirmBoxWithImage("Whatsapp Module","WhatsApp is not enabled in your account, Please contact support to enable the same",'',"","OK","",false,false,false,false);
            return;
        } else if (actionName === "send_sms" && !isAddonModuleEnabled("send_sms")){
            await confirmBoxWithImage("SMS Module","SMS is not enabled in your account, Please contact support to enable the same",'',"","OK","",false,false,false,false);
            return;
        } else if (actionName === "send_email" && !isAddonModuleEnabled("send_email")){
            await confirmBoxWithImage("Email Module","Email is not enabled in your account, Please contact support to enable the same",'',"","OK","",false,false,false,false);
            return;
        } /*else if (actionName === "webhook"){
            await confirmBoxWithImage("Webhook",'The "Send Webhooks" feature is coming soon.','',"","OK","",false,false,false,false);
            return;
        }*/
        if(actionName === "create_task"){
            editor = <TaskAction
                closeModal={this.toggleActionEditorModal}
                screenDetail={screenDetail}
                onSelectChange={onSelectChange}
                typeofaction="Create Task"
                actions={actions}
                actionIndex={index}
                systemActionSubmit={systemActionSubmit}
                enableActionDelay={this.enableActionDelay}
             />
        } else if(actionName === "update_field"){
            editor = <UpdateAction
                closeModal={this.toggleActionEditorModal}
                screenDetail={screenDetail}
                onSelectChange={onSelectChange}
                typeofaction="Update"
                actions={actions}
                actionIndex={index}
                systemActionSubmit={systemActionSubmit}
                enableActionDelay={this.enableActionDelay}
             />
        } else if(actionName === "send_email" || actionName === "send_sms"){
            let channel = "email";
            let titleTxt = "Send Email";
            let typeofaction = titleTxt;
            if(actionName === "send_whatsapp"){
                channel = "whatsapp";
                titleTxt = "Send Whatsapp";
                typeofaction = titleTxt;
            } else if(actionName === "send_sms"){
                channel = "sms";
                titleTxt = "Send SMS";
                typeofaction = titleTxt;
            }
            editor = <SendAction
                closeModal={this.toggleActionEditorModal}
                channel={channel}
                titleTxt={titleTxt}
                typeofaction={typeofaction}
                screenDetail={screenDetail}
                onSelectChange={onSelectChange}
                actions={actions}
                actionIndex={index}
                systemActionSubmit={systemActionSubmit}
                enableActionDelay={this.enableActionDelay}
             />
        } else if (actionName === "send_whatsapp"){
            let waTempDetails = await getWATemplateDetails("workflowAction");
            let waTemplates = {};
            let waOptions = [];
            if(waTempDetails.length > 0){
                waTemplates = waTempDetails[0];
                waOptions = waTempDetails[1];
            }
            let formData = {};
            let formDetail = screenDetail.length > 0 ? screenDetail[0]: [];
            let fieldDetails = screenDetail.length > 0 ? screenDetail[1] : [];
            let formname = formDetail.length > 0 ? formDetail[1] : "";
            let tPreviewData = {};
            if(actions[index] !== undefined){
                let {formInputData, previewData} = await this.prepareWhatsappTemplateEditor(actions[index], waTemplates, fieldDetails);
                formData = formInputData;
                tPreviewData = previewData;
            } else {
                formData = {'formname' : formname};
            }
            editor = <QuickReplyOperations
                key={randstr('quickrep_')}
                showActionModal={true}
                quickReplyId={"triggerid"}
                toggleActionsModal={this.onWhatsappTemplateSave}
                type={"workflowAction"}
                waOptions={waOptions}
                waTemplates={waTemplates}
                useForm={this.props.useForm}
                notificationFormData={formData}
                previewData={tPreviewData}
            />
        } else if(actionName === "webhook"){
            editor = <SendWebhookAction
                closeModal={this.toggleActionEditorModal}
                screenDetail={screenDetail}
                typeofaction={"Send Webhook"}
                actions={actions}
                actionIndex={index}
                systemActionSubmit={systemActionSubmit}
                enableActionDelay={this.enableActionDelay}
            />
        }
        this.setState({
            isShowEditorModal: true,
            currentEditor : editor,
            currentActionName : actionName
        });
    }

    prepareWhatsappTemplateEditor = async (action, waTemplates, fieldDetails) => {
        let formInputData = action;
        let systemActionStr = formInputData['systemActionStr'];
        let templateData = formInputData['waTemplate'];
        /*if(templateData === undefined){
            let formTemplate = formInputData['waTemplate'];
            if(formTemplate !== undefined){
                templateData = [];
                templateData.push(formTemplate.value);
                templateData.push(formTemplate.label);
            }
        }*/
        let {subject, toRecp, cc} = await parseSendActionExpression(systemActionStr);
        let recpOptions = await populateRecipientOptionList(fieldDetails, "whatsapp");
        let {recipientOptions, extraRecipients} = await parseExtraRecipients(toRecp, recpOptions, "whatsapp");
        formInputData["recipients"] = recipientOptions;
        formInputData["extra_recipients"] = extraRecipients;
        let previewData = {};
        if(templateData !== undefined){
            let templateId = templateData['value'];
            let templateName = templateData['label'];
            let components = formInputData['Components'];
            let waTemplate = waTemplates[templateId];
            if(waTemplate != undefined){
                let selectedTemplate = {value : templateId, label : templateName};
                formInputData['selectedTemplate'] = selectedTemplate;
                //formInputData['Components'] = components;
                let parsedComponents = waTemplate['Components'] !== undefined ? parseJSON(decodeString(waTemplate['Components'])) : {};

                if(Object.keys(parsedComponents).length > 0){
                    let waComponents = getWAComponents(parsedComponents);
                    let bodyComponent = waComponents['BODY'];
                    let messageTxt = bodyComponent['text'];
                    formInputData['Message'] = messageTxt;
                    if(components !== "" && components !== null && components !== "null"){
                        let otherComponents = components ;//parseJSON(components);
                        if(otherComponents && Object.keys(otherComponents).length > 0){
                        let header = otherComponents['header'];
                        formInputData['mediaUrl'] = header !== undefined && header['mediaUrl'] !== undefined ? header['mediaUrl'] : '';
                        let headerVariables = header !== undefined && header['variables'] !== undefined ? header['variables'] : {};
                        let body = otherComponents['body'];
                        let variables = body['variables'];
                        for(let v = 0; v < variables.length; v++){
                            let variableSelect = variables[v];
                            let vIndex = variableSelect.parameter_name ? variableSelect.parameter_name : v + 1;
                            let tmpSelect = {
                                value : variableSelect.value,
                                label : variableSelect.label,
                                fieldType : variableSelect.fieldType
                            }
                            let objName = "body_variable_field_"+vIndex;
                            previewData[objName] = variableSelect.value;
                            previewData[objName+"_label"] = variableSelect.label;
                            formInputData[objName+"_selected"] = this.props.resetAllCampVariables !== undefined && this.props.resetAllCampVariables ? {} : tmpSelect;
                            formInputData["body_df_value_field_"+vIndex] =  this.props.resetAllCampVariables !== undefined && this.props.resetAllCampVariables ? '' : variableSelect.defaultvalue;
                        }
                        if(Object.keys(headerVariables).length > 0){
                            let tmpHeaderSelect = {
                                value : headerVariables.value,
                                label : headerVariables.label,
                                fieldType : headerVariables.fieldType
                            }
                            let objName = "header_variable_1";
                            previewData[objName] = headerVariables.value;
                            previewData[objName+"_label"] = headerVariables.label;
                            formInputData[objName+"_selected"] = tmpHeaderSelect;
                            if(headerVariables.defaultvalue !== undefined && headerVariables.defaultvalue !== ""){
                                formInputData["header_df_value_field_1"] = headerVariables.defaultvalue;
                            }
                        }
                    }
                    }
                }
            }
        }
        let editorData = [];
        editorData['previewData'] = previewData;
        editorData['formInputData'] = formInputData;
        return editorData;
    }

    onWhatsappTemplateSave = async(isModalClose, formData) => {
        if(formData !== undefined){
            let systemActionStr = await getSystemActionContent(formData['recipients'], formData['extra_recipients'], "", "", "whatsapp");
            formData["systemActionStr"] = systemActionStr;
            formData["typeofaction"] = "Send Whatsapp";
            let {index,systemActionSubmit} = this.props;
            systemActionSubmit(formData, index);
            this.enableActionDelay();
        }
        this.setState({
            isShowEditorModal : isModalClose
        })
    }

    toggleActionEditorModal = () => {
        this.setState({
            isShowEditorModal: !this.state.isShowEditorModal,
        });
    }

    delayConditionChange = async(e) =>{
        let name = e.target.name;
        let value = e.target.value;
        let {conditionData} = this.state;
        conditionData[name] = value;
        this.setState({conditionData});
        let {onActionExecutionChange, actions, index} = this.props;
        onActionExecutionChange("delayValue",index, value);
    }

    conditionTypeChange = async(selected, delayTypeName) =>{
        this.setState({
            defaultDuration : selected,
        });
        let {onActionExecutionChange, actions, index} = this.props;
        onActionExecutionChange("delayType",index, selected.value);
    }

    render () {
        let {actionList, index, isShowEditorModal, currentEditor, actionBtnTxt, defaultDuration, conditionData, showActionDelay, disableChangeAction, currentActionName, actions} = this.state;
        let {control, errors, onSelectChange, selectedActions, incrementActionCount,decreaseActionCount, isLast, aCount, selectedUserAction,screenDetail} = this.props;
        let formDetail = screenDetail.length > 0 ? screenDetail[0]: [];
        let formname = formDetail.length > 0 ? formDetail[1] : "";
        //let newWorkFlowActionList = selectedUserAction.value !== "Auto" ? workflow_action_list : [];
        let newWorkFlowActionList = [];
        if (selectedUserAction.value !== "Auto") {
            if (formname === "table_37") {
                newWorkFlowActionList = [workflow_action_list[workflow_action_list.length - 1]];
            } else {
                newWorkFlowActionList = workflow_action_list;
            }
        }
        if(selectedUserAction.value === "Auto"){
            for(let wl = 0; wl < workflow_action_list.length; wl++){
                let actionOption = workflow_action_list[wl];
                if(actionOption.value !== "webhook"){
                    newWorkFlowActionList.push(actionOption);
                }
            }
        }
        return <Fragment>
            <div className='workflow-action-list-container'>
                {
                    isShowEditorModal && currentActionName !== "send_whatsapp" && currentEditor !== "" && <Modal isOpen={true} toggle={this.toggleActionEditorModal}
                    className={`${ currentActionName !== "create_task" && currentActionName !== "update_field" && currentActionName !== "webhook" ? "workflow-modal-md" :"workflow-modal-sd"} campaign-modal workflow-actions-modal`}>
                        <ModalBody>
                            {currentEditor}
                        </ModalBody>
                    </Modal>
                }
                {
                    isShowEditorModal && currentActionName === "send_whatsapp" && currentEditor !== "" && currentEditor
                }
                <div className={cx('workflow-action', {})}>
                    <div className={'d-flex-alone'}>
                        
                        <Col md={"10"} className={'align-center'}>
                            <div className='col-md-12 d-flex-alone'>
                            <div className={cx('campaign-action-number ',{})}>
                                <span>{index + 1}</span>
                                </div>
                            <div className='col-md-3'>
                                
                                <Controller
                                    name={"action_type_"+index}
                                    control={control}
                                    rules={{ required: selectedActions["action_type_"+index] === undefined ? "Choose any action to be performed" : false }}
                                    render={({ field }) => {
                                        return (
                                            <Select
                                                {...field}
                                                placeholder={'---Choose One---'}
                                                menuPlacement={"auto"}
                                                menuPosition={'fixed'}
                                                name={"action_type_"+index}
                                                id={"action_type_"+index}
                                                className={`basic-multi-select ${errors["action_type_"+index] ? 'is-invalid' : ''}`}
                                                classNamePrefix="wa-select"
                                                value={Object.keys(selectedActions).length === 0 ? false : selectedActions["action_type_"+index]}
                                                onChange={e => {
                                                    onSelectChange(e,"action_change" ,"action_type_"+index);
                                                    this.onActionChange(e, "action_type_"+index);
                                                    field.onChange(e);
                                                }}
                                                isDisabled={disableChangeAction}
                                                options={newWorkFlowActionList}
                                            />
                                        );
                                    }}
                                />
                                {errors["action_type_"+index] && <em className={`error invalid-feedback`}>{errors["action_type_"+index].message}</em>}
                            </div>
                            {Object.keys(actionList).length > 0 && 
                                <div className='d-flex-alone col-md-9'>
                                <div className='col-md-8 ml-1'>
                                <div className='d-flex-alone wh-100'>
                                    {actionList["action_type_"+index] !== undefined &&
                                        <div className='col-md-12'>
                                            <a onClick={(e) => this.configureActionContent(e, actionList["action_type_"+index].value)} className='wh-100 action-btn-name btn btn-outline-success text-truncate'>{actionBtnTxt}</a>
                                        </div>
                                    }
                                </div>
                                </div>
                                {showActionDelay && 
                                <div className={cx('delay-condition col-md-4 d-flex-alone',) }>
                                    <div className={'w-100'}>
                                        <div className={cx('w-100 d-flex-alone condition-block justify-content-right',{'d-flex-alone ' : defaultDuration.value !== "immediate"})}>
                                            {
                                                defaultDuration.value !== "immediate" /*&& delayValue !== ""*/ &&
                                                <input autoComplete='off' value={conditionData.delay_value} type={"text"} name={"delay_value"}
                                                    placeholder={'xx'} onChange={(e) => {
                                                    this.delayConditionChange(e)
                                                    }} className={cx('form-control delay-box col-md-1')} required={true}/>
                                            }
                                            <Select 
                                            name="delay-condition" 
                                            menuPlacement={"auto"}
                                            menuPosition={'fixed'}
                                            className={"condition-block-select"} 
                                            classNamePrefix="wa-select" 
                                            id={`delay-condition-select ${defaultDuration.value === "immediate" ? 'immediate-width' : ''}`} 
                                            value={defaultDuration} 
                                            onChange={(e) => (this.conditionTypeChange(e))} 
                                            options={duration_option_list}/>
                                        </div>
                                    </div>
                                </div>
                                }
                                </div>
                                }
                            </div>
                        </Col>
                        <Col md={'2'} className={cx('campaign-action-buttons',{})}>
                            <div className={'form-group'}>
                                <div className={'form-row-action-buttons'}>
                                    {(index > 0 || (index === 0 && aCount > 1)) && <FontAwesomeIcon onClick={(e) => decreaseActionCount(e, index)} icon={faTrash} />}
                                    {isLast && <FontAwesomeIcon onClick={(e) => incrementActionCount(e)} icon={faPlus} />}
                                </div>
                            </div>
                        </Col>
                    </div>
                </div>
            </div>
        </Fragment>
    }
}

export default ActionList;
